// Acción de carga obtener traspasos servicio 
export const TRASPASOS_SERVICIO_SUCCESS = 'TRASPASOS_SERVICIO_SUCCESS';
export const TRASPASOS_SERVICIO_FAIL = 'TRASPASOS_SERVICIO_FAIL';
export const TRASPASOS_SERVICIO_REQUEST = 'TRASPASOS_SERVICIO_REQUEST';

// Acción de carga obtener establecimiento
export const ESTABLECIMIENTO_SUCCESS = 'ESTABLECIMIENTO_SUCCESS';
export const ESTABLECIMIENTO_FAIL = 'ESTABLECIMIENTO_FAIL';
export const ESTABLECIMIENTO_REQUEST = 'ESTABLECIMIENTO_REQUEST';

// Acción de carga obtener especie
export const TRASPASOS_ESPECIE_SUCCESS = 'TRASLADO_ESPECIE_SUCCESS';
export const TRASPASOS_ESPECIE_FAIL = 'TRASLADO_ESPECIE_FAIL';
export const TRASPASOS_ESPECIE_REQUEST = 'TRASLADO_ESPECIE_REQUEST';

// Acción de carga obtener dependencia origen
export const COMBO_DEPENDENCIA_T_ORIGEN_REQUEST = 'COMBO_DEPENDENCIA_T_ORIGEN_REQUEST';
export const COMBO_DEPENDENCIA_T_ORIGEN_SUCCESS = 'COMBO_DEPENDENCIA_T_ORIGEN_SUCCESS';
export const COMBO_DEPENDENCIA_T_ORIGEN_FAIL = 'COMBO_DEPENDENCIA_T_ORIGEN_FAIL';

// Acción de carga obtener dependencia destino
export const COMBO_DEPENDENCIA_DESTINO_REQUEST = 'COMBO_DEPENDENCIA_DESTINO_REQUEST';
export const COMBO_DEPENDENCIA_DESTINO_SUCCESS = 'COMBO_DEPENDENCIA_DESTINO_SUCCESS';
export const COMBO_DEPENDENCIA_DESTINO_FAIL = 'COMBO_DEPENDENCIA_DESTINO_FAIL';

// Acción de carga Listado de Traspasos enviados
export const LISTA_TRASPASOS_ENVIADOS_REQUEST = 'LISTA_TRASPASOS_ENVIADOS_REQUEST';
export const LISTA_TRASPASOS_ENVIADOS_SUCCESS = 'LISTA_TRASPASOS_ENVIADOS_SUCCESS';
export const LISTA_TRASPASOS_ENVIADOS_FAIL = 'LISTA_TRASPASOS_ENVIADOS_FAIL';

// Acción de carga Listado de Traspasos enviados con filtro para comprobantes
export const FILTRO_TRASPASOS_ENVIADOS_REQUEST = 'FILTRO_LISTA_TRASPASOS_ENVIADOS_REQUEST';
export const FILTRO_TRASPASOS_ENVIADOS_SUCCESS = 'FILTRO_LISTA_TRASPASOS_ENVIADOS_SUCCESS';
export const FILTRO_TRASPASOS_ENVIADOS_FAIL = 'FILTRO_LISTA_TRASPASOS_ENVIADOS_FAIL';

// Acción de carga Listado de Traspasos recibidos
export const LISTA_TRASPASOS_RECIBIDOS_REQUEST = 'LISTA_TRASPASOS_RECIBIDOS_REQUEST';
export const LISTA_TRASPASOS_RECIBIDOS_SUCCESS = 'LISTA_TRASPASOS_RECIBIDOS_SUCCESS';
export const LISTA_TRASPASOS_RECIBIDOS_FAIL = 'LISTA_TRASPASOS_RECIBIDOS_FAIL';

// Acción de registra formulario traslados 
export const POST_FORMULARIO_TRASPASO_REQUEST = 'POST_FORMULARIO_TRASPASO_REQUEST';
export const POST_FORMULARIO_TRASPASO_SUCCESS = 'POST_FORMULARIO_TRASPASO_SUCCESS';
export const POST_FORMULARIO_TRASPASO_FAIL = 'POST_FORMULARIO_TRASPASO_FAIL';

// Acción de obtiene formulario inventario traspasos 
export const OBTIENE_INV_TRASPASOS_REQUEST = 'OBTIENE_INV_TRASPASOS_REQUEST';
export const OBTIENE_INV_TRASPASOS_SUCCESS = 'OBTIENE_INV_TRASPASOS_SUCCESS';
export const OBTIENE_INV_TRASPASOS_FAIL = 'OBTIENE_INV_TRASPASOS_FAIL';

// Acción que actualiza el estado de recibe traspaso
export const TRASPASO_ESTADO_RECIBE_REQUEST = 'TRASPASO_ESTADO_RECIBE_REQUEST';
export const TRASPASO_ESTADO_RECIBE_SUCCESS = 'TRASPASO_ESTADO_RECIBE_SUCCESS';
export const TRASPASO_ESTADO_RECIBE_FAIL = 'TRASPASO_ESTADO_RECIBE_FAIL';

//Acción consulta documentos adjuntos de traspasos por fila
export const LISTA_TRASPASOS_ADJUNTOS_REQUEST = 'LISTA_TRASPASOS_ADJUNTOS_REQUEST';
export const LISTA_TRASPASOS_ADJUNTOS_SUCCESS = 'LISTA_TRASPASOS_ADJUNTOS_SUCCESS';
export const LISTA_TRASPASOS_ADJUNTOS_FAIL = 'LISTA_TRASPASOS_ADJUNTOS_FAIL';
